<h2>upp-panel — Dashboard Cards</h2>
<p class="demo-description">Three <code>upp-panel</code> cards forming a mini dashboard. Each has a header, metric content, and footer with actions.</p>

<div class="demo-controls">
    <ion-button size="small" (click)="toggleLines()">Lines: {{ panelLines }}</ion-button>
    <ion-button size="small" (click)="cycleSize(0)">Sales: {{ panelSizes[0] }}</ion-button>
    <ion-button size="small" (click)="cycleSize(1)">Orders: {{ panelSizes[1] }}</ion-button>
    <ion-button size="small" (click)="cycleSize(2)">Alerts: {{ panelSizes[2] }}</ion-button>
</div>

<div class="panel-row">
    <div class="panel-col" *ngFor="let card of cards; let i = index">
        <div class="panel-wrapper">
            <upp-panel [size]="panelSizes[i]" [lines]="panelLines">
                <upp-panel-header>
                    <upp-header [color]="card.color" menu="hide" height="40px">
                        <upp-header-title>{{ card.title }}</upp-header-title>
                        <upp-header-button>
                            <ion-icon [name]="card.icon"></ion-icon>
                        </upp-header-button>
                    </upp-header>
                </upp-panel-header>
                <upp-panel-content>
                    <div class="metric">
                        <span class="metric-value">{{ card.value }}</span>
                        <span class="metric-label">{{ card.label }}</span>
                    </div>
                </upp-panel-content>
                <upp-panel-footer>
                    <ion-item lines="none" button detail>
                        <ion-icon name="arrow-forward-outline" slot="start" color="medium"></ion-icon>
                        <ion-label color="medium">View details</ion-label>
                    </ion-item>
                </upp-panel-footer>
            </upp-panel>
        </div>
    </div>
</div>
